<template>
  <v-expansion-panels>
    <base-section
      v-for="({ name, fields }, index) in schema"
      :key="index"
      :name="name"
      :is-done="isDone(fields)"
    >
      <slot name="beforeFields" v-bind:sectionName="name" v-bind:fields="fields" />

      <base-fields
        :initial-values="initialValues"
        :fields="fields"
        :meta="meta"
        @updateMeta="updateValueMeta"
        @updateSchema="updateSchema"
      />
    </base-section>
  </v-expansion-panels>
</template>

<script>
import BaseSection from '@/components/form-generator/BaseSection.vue';
import BaseFields from '@/components/form-generator/BaseFields.vue';

export default {
  props: {
    initialValues: {
      type: Object,
    },
    schema: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      meta: {},
    };
  },
  methods: {
    updateValueMeta(value) {
      Object.entries(value).forEach(([key, value]) => {
        this.$set(this.meta, key, value);
      });
    },
    updateSchema(schema) {
      this.$emit('update', schema);
    },
    isDone(fields) {
      return fields.every(({ disabled }) => disabled);
    },
  },
  components: {
    BaseFields,
    BaseSection,
  },
};
</script>
